module.exports = __webpack_public_path__ + "img/ELearningTitleMine.1b45d392.png";